import { forwardRef, type Ref, type SVGProps } from "react";
const IconStar0PercentSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 4.69 19.24 11l.45.88 1 .19 7 1.29-5 5.39-.64.68.12.93 1 7.28-6.2-3.14-.97-.45-.92.47-6.2 3.14 1-7.28.12-.93-.64-.68-5-5.39 7-1.29 1-.19.45-.88zM16 2c-.55 0-1.09.41-1.51 1.22L11 10.12l-7.28 1.34c-1.8.34-2.26 1.71-1 3.06l5.16 5.6-1 7.78c-.17 1.32.39 2.1 1.34 2.1a2.7 2.7 0 0 0 1.19-.33L16 26.3l6.65 3.37a2.7 2.7 0 0 0 1.19.33c.95 0 1.51-.78 1.34-2.1l-1-7.78 5.16-5.6c1.24-1.35.78-2.72-1-3.06L21 10.12l-3.52-6.9C17.09 2.41 16.55 2 16 2" />
  </svg>
);
const ForwardRef = forwardRef(IconStar0PercentSVG);
ForwardRef.displayName = "IconStar0Percent";
export { ForwardRef as IconStar0Percent };
